// start:ng42.barrel
export * from './bv-reviews.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/bv-reviews/index.ts